import(/* webpackMode: "eager" */ "C:\\Users\\shubh\\OneDrive\\Desktop\\Documents\\MMI-FREELANCING\\NEW projects\\MMI-main\\node_modules\\next\\dist\\client\\link.js");
